export function HeroSkeleton() {
  return (
    <div className="relative bg-gradient-to-r from-blue-900 to-brand-primary py-16 md:py-32">
      <div className="container-page relative z-1">
        <div className="animate-pulse max-w-4xl mx-auto text-center">
          <div className="h-8 bg-white/20 rounded-full w-64 mx-auto mb-8"></div>
          <div className="h-16 bg-white/20 rounded-lg w-3/4 mx-auto mb-6"></div>
          <div className="h-12 bg-white/20 rounded-lg w-2/3 mx-auto mb-10"></div>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <div className="h-14 bg-white/20 rounded-md w-48 mx-auto sm:mx-2"></div>
            <div className="h-14 bg-white/20 rounded-md w-48 mx-auto sm:mx-2"></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export function ProductsSkeleton() {
  return (
    <div className="py-16 bg-gray-50">
      <div className="container-page">
        <div className="animate-pulse">
          <div className="h-10 bg-gray-200 rounded w-64 mx-auto mb-4"></div>
          <div className="h-6 bg-gray-200 rounded w-96 mx-auto mb-12"></div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[...Array(3)].map((_, i) => (
              <div key={i} className="bg-white rounded-xl p-6 shadow-lg">
                <div className="h-48 bg-gray-200 rounded-lg mb-4"></div>
                <div className="h-6 bg-gray-200 rounded w-3/4 mb-3"></div>
                <div className="h-4 bg-gray-200 rounded w-5/6 mb-4"></div>
                <div className="flex justify-between items-center">
                  <div className="h-4 bg-gray-200 rounded w-24"></div>
                  <div className="h-4 bg-gray-200 rounded w-16"></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export function TestimonialsSkeleton() {
  return (
    <div className="py-16 bg-white">
      <div className="container-page">
        <div className="animate-pulse">
          <div className="h-10 bg-gray-200 rounded w-64 mx-auto mb-4"></div>
          <div className="h-6 bg-gray-200 rounded w-96 mx-auto mb-12"></div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[...Array(3)].map((_, i) => (
              <div key={i} className="bg-gray-50 rounded-xl p-6">
                <div className="flex items-center mb-6">
                  <div className="w-16 h-16 bg-gray-200 rounded-full mr-4"></div>
                  <div>
                    <div className="h-5 bg-gray-200 rounded w-32 mb-2"></div>
                    <div className="h-4 bg-gray-200 rounded w-24"></div>
                  </div>
                </div>
                <div className="h-20 bg-gray-200 rounded"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export function TrustIndicatorsSkeleton() {
  return (
    <div className="py-16 bg-gray-50">
      <div className="container-page">
        <div className="animate-pulse">
          <div className="h-10 bg-gray-200 rounded w-64 mx-auto mb-4"></div>
          <div className="h-6 bg-gray-200 rounded w-96 mx-auto mb-12"></div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            {[...Array(3)].map((_, i) => (
              <div key={i} className="bg-white rounded-xl p-6 text-center">
                <div className="h-24 bg-gray-200 rounded mb-4 mx-auto w-32"></div>
                <div className="h-6 bg-gray-200 rounded w-40 mx-auto mb-2"></div>
                <div className="h-4 bg-gray-200 rounded w-56 mx-auto"></div>
              </div>
            ))}
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[...Array(4)].map((_, i) => (
              <div key={i} className="bg-white rounded-xl p-6 text-center">
                <div className="w-16 h-16 bg-gray-200 rounded-full mx-auto mb-4"></div>
                <div className="h-6 bg-gray-200 rounded w-32 mx-auto mb-2"></div>
                <div className="h-4 bg-gray-200 rounded w-48 mx-auto"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
} 